$(document).ready(function() {
    $(document).foundation();
  //filter products on shop page
    var $filter_dropdown = $( "#product-filter-dropdown" );
    var $products = $('[data-product-tags]');
  
    var $filters = $('[type="checkbox"].filter-child');
    var $filter_parents_wrap = $('.filter-parent-wrap');
    var $filter_parents = $('.filter-parent');
    var $default_filters = $('.filter-child.default');
    var $not_default_filters = $('.filter-child:not(.default)');
  
    var $open_filters = $('#open-filters');
    var $filter_button = $('button[name="product-filter"]:not(.remove-tag)');
    var $clear_filters = $('.clear-filters');
    var $close_filters = $('.close-filters');
  
     $open_filters.click(function(){
      openFilters();
    });
  
    $close_filters.click(function(){
      closeFilters();
    });
  
    $clear_filters.click(function(){
      $filters.prop( "checked", false );
      filterUpdateUrl();
      filterProducts();
      closeFilters(100);
    });
  
    function openFilters(){
      $open_filters.parent().css('margin-bottom', $filter_dropdown.outerHeight( true ));
      $filter_dropdown.addClass('open');
     // $filter_dropdown.css('paddingTop', $header.outerHeight());
      //$filter_dropdown.css('paddingBottom', $checkout_popup.outerHeight());
      $('body').addClass('js-filter-open');
      //$header.removeClass('nav-up');
    }
  
    function closeFilters(timeout){
      timeout = timeout || 0;
      $open_filters.parent().css('margin-bottom', 0);
      setTimeout(function(){
        $filter_dropdown.removeClass('open');
      }, timeout);
      $('.dropdown-pane').foundation('close');
      $('body').removeClass('js-filter-open');
    }
    $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize){
    if(oldSize == 'small'){
      updateFilterPlugin(true);
    } else if(newSize == 'small'){
      updateFilterPlugin(false);
    }
  });
    function updateFilterPlugin(is_dropdown){
    var $dropdown = $('.filter-dropdown');
    if(!$dropdown.length){ return; }
    if(is_dropdown){
      $('.filter-dropdown').foundation('_destroy');
      $('.filter-dropdown').removeAttr( 'style' );
      $('.filter-dropdown').each(function(){
        var elem = new Foundation.Dropdown($(this), {hover: true, hoverPane: true});
      });
    } else {
      $('.filter-dropdown').foundation('_destroy');
      $('.filter-dropdown').removeAttr( 'style' );
      $('.filter-dropdown').each(function(){
        var elem = new Foundation.Dropdown($(this), {hover: false, hoverPane: false});
      });
    }
  }
     var $filterBy = $('[name="blog-filter"]');
   if(Foundation.MediaQuery.atLeast('medium')){
      updateFilterPlugin(true);
    }
    $filterBy.on('change', function() {
      if($(this).is(':checked')){
        location.href = $(this).val() + '#filter';
      }
    });
  
    $('.remove-tag-blog').click(function(){
      location.href = $(this).val();
    })
    
  });